import { memo } from "react";

import { TableItemId } from "../../../../../components/tables/TableWidget";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";

import { TableItemType } from "../../../../../components/tables/tableContext/TableContext";
import { expeditionRoutes } from "../../../../../router/routesConstants";

function ExpeditionScheduleWorkingPointsTableActionButtons({
  itemId,
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: any;
  tableContext?: any;
}) {
  const goToOrganizeWorkingPoint = () => {
    return `/${expeditionRoutes.scheduleWorkingPoints}/${expeditionRoutes.organize}?id=${itemId}&routeId=${crudData.rutaId}&pctDeLivr=${crudData.pctDeLivr}`;
  };

  return (
    <div className="text-left">
      <ActionMenu
        minItemsForMenu={2}
        title={crudData.pctDeLivr}
        ariaLabel={`Actiuni pentru punctul de lucru ${crudData.pctDeLivr}`}
        items={[
          {
            id: "organize",
            label: "Organizare",
            icon: "DOCUMENTS",
            tooltip: "Configureaza ruta si zilele pentru acest punct de lucru.",
            navigate: goToOrganizeWorkingPoint(),
          },
        ]}
      />
    </div>
  );
}

export default memo(ExpeditionScheduleWorkingPointsTableActionButtons);
